import { __zcFin, __zcFinZ, __zcMkv } from "__zod-compiler-runtime__";
import {safeOptional} from '../../safe-optional'
import * as z from 'zod'

export const AssetSchema = /* @__PURE__ */ (() => {
var __zs=z.lazy(() =>
  z.object({
    fields: z.object({
      description: z.string().optional(),

      file: z.object({
        url: z.string(),
        details: safeOptional(
          z.object({
            image: safeOptional(
              z.object({
                width: z.number(),
                height: z.number(),
              }),
            ),
          }),
        ),
      }),
    }),
  }),
);
var __rf=[__zs._zod.innerType.shape["fields"].shape["file"].shape["details"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __bf_2={};
var __rfn_9=__rf[0];
function __vb_14(input){var __bv_3,__bv_4,__bv_5,__bv_6,__bv_7,__bx_8,__bw_10,__bo_11,__bo_12,__bo_13;if(typeof input!=="object"||input===null||Array.isArray(input))return __bf_2;__bv_3=input["fields"];if(typeof __bv_3!=="object"||__bv_3===null||Array.isArray(__bv_3))return __bf_2;__bv_4=__bv_3["description"];if(!((__bv_4===undefined||(typeof __bv_4==="string"))))return __bf_2;__bv_5=__bv_3["file"];if(typeof __bv_5!=="object"||__bv_5===null||Array.isArray(__bv_5))return __bf_2;__bv_6=__bv_5["url"];if(!(typeof __bv_6==="string"))return __bf_2;__bv_7=__bv_5["details"];if(__bv_7===undefined){__bw_10=undefined;}else{__bx_8=__rfn_9(__bv_7);__bw_10=__bx_8;}__bo_11={"url":__bv_6};if(__bw_10!==undefined||("details" in __bv_5)){__bo_11["details"]=__bw_10;}__bo_12={};if(__bv_4!==undefined||("description" in __bv_3)){__bo_12["description"]=__bv_4;}__bo_12["file"]=__bo_11;__bo_13={"fields":__bo_12};return __bo_13;}
var __rfm_z=__zs.safeParse;
function safeParse_AssetSchema(input){
var __bd_15=__vb_14(input);
if(__bd_15!==__bf_2){return{success:true,data:__bd_15};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_AssetSchema,__zs,null,null);
})()

export type Asset = z.infer<typeof AssetSchema>
